<template>
  <div class="addAddress absolute">
    <div class="list" style="background-color: white">
      <div class="item acea-row row-between-wrapper">
        <div class="name">卡号</div>
        <input
          type="text"
          placeholder="请输入卡号"
          v-model="receive.code"
          required
          disabled
        />
      </div>
      <div class="item acea-row row-between-wrapper">
        <div class="name">姓名</div>
        <input
          type="text"
          placeholder="请输入收件人姓名"
          v-model="receive.name"
          required
          maxlength="50"
        />
      </div>
      <div class="item acea-row row-between-wrapper">
        <div class="name">联系电话</div>
        <input
          type="text"
          placeholder="请输入联系电话"
          v-model="receive.phone"
          required
          maxlength="40"
        />
      </div>
      <div class="item acea-row row-between-wrapper">
        <div class="name">所在地区</div>
        <div
          class="picker acea-row row-between-wrapper select-value form-control"
        >
          <div class="address">
            <div slot="right" @click.stop="show2 = true">
              {{ model2 || "请选择收货地址" }}
            </div>
            <CitySelect
              ref="cityselect"
              v-model="show2"
              :callback="result2"
              :items="district"
              :ready="ready"
              provance=""
              city=""
              area=""
            ></CitySelect>
          </div>
          <div class="iconfont icon-dizhi font-color-red"></div>
        </div>
      </div>
      <div class="item acea-row row-between-wrapper">
        <div class="name">详细地址</div>
        <textarea
          placeholder="请填写具体地址"
          v-model="receive.detail"
          required
          maxlength="200"
          rows="3"
        />
      </div>
      <div class="item acea-row row-between-wrapper">
        <div class="name">期望发货日期</div>
        <div class="acea-row row-between-wrapper">
          <cell
            :value="receive.date ? receive.date : '选择期望发货日期(选填)'"
            :class="receive.date ? 'checkDate' : 'noCheckedDate'"
            @click="show = true"
            is-link
          />
        </div>
        <!--        <calendar v-model="show" @confirm="onConfirm" />-->
        <calendar
          v-model="show"
          :min-date="minDate"
          :max-date="maxDate"
          :formatter="formatter"
          first-day-of-week="1"
          :show-confirm="false"
          @confirm="onConfirm"
        />
      </div>

      <div class="hint">
        <span>（未选择期望发货日期，默认7天内发货）</span>
      </div>

      <div class="item acea-row row-between-wrapper">
        <div class="name">备注</div>
        <textarea
          placeholder="请输入备注"
          v-model="receive.remark"
          required
          maxlength="200"
          rows="4"
        />
      </div>
    </div>

    <div class="tips" v-if="tips">温馨提示：{{ tips }}</div>

    <!-- <div class="drag" ref="dragDiv">
      <div class="drag_bg"></div>
      <div class="drag_text">{{confirmWords}}</div>
      <div ref="moveDiv" @touchstart="mousedownFn($event)" :class="{'handler_ok_bg':confirmSuccess}" class="handler handler_bg" style="position: absolute;top: 0px;left: 0px;height: 34px"></div>
    </div> -->

    <div></div>
    <div
      class="keepBnt bg-color-red"
      style="border-radius:0px"
      @click="submit"
      v-if="allowDelivery && !loading"
    >
      立即提货
    </div>
    <div class="nokeepBnt" style="border-radius:0px" v-else>
      立即提货
    </div>
  </div>
</template>

<script>
import { CitySelect } from "vue-ydui/dist/lib.rem/cityselect";
import { getCity } from "@api/user";
import { chs_phone, required } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import { postTakeGiftTicket, getConfig } from "@api/giftticket";
import { encrypt } from "@/utils/jsencrypt";
import { Calendar, Cell } from "vant";

export default {
  name: "takeGoods",
  components: {
    CitySelect,
    Calendar,
    Cell
  },
  props: {},
  data: function() {
    return {
      show2: false,
      model2: "",
      district: [],
      ready: false,
      address: {},
      code: "",
      receive: {},
      minDate: new Date(new Date().setDate(new Date().getDate() + 2)),
      maxDate: new Date(2025, 0, 10),

      beginClientX: 0 /*距离屏幕左端距离*/,
      mouseMoveStata: false /*触发拖动状态  判断*/,
      maxwidth: "" /*拖动最大宽度，依据滑块宽度算出来的*/,
      confirmWords: "拖动滑块验证" /*滑块文字*/,
      confirmSuccess: false /*,验证成功判断*/,

      show: false,
      loading: false,
      allowDelivery: false,
      weekend: "0",
      holidays: "1",
      dateList: [],
      tips: ""
    };
  },
  mounted: function() {
    this.code = this.$route.params.code;
    this.receive.code = this.code;
    this.getCityList();
    this.getTakeGoodsConfig();
    // this.maxwidth =
    //   this.$refs.dragDiv.clientWidth - this.$refs.moveDiv.clientWidth;
    // document
    //   .getElementsByTagName("html")[0]
    //   .addEventListener("touchmove", this.mouseMoveFn);
    // document
    //   .getElementsByTagName("html")[0]
    //   .addEventListener("touchend", this.moseUpFn);
  },
  methods: {
    getCityList: function() {
      let that = this;
      getCity()
        .then(res => {
          that.district = res.data;
          that.ready = true;
        })
        .catch(err => {
          that.$dialog.error(err.msg);
        });
    },
    getTakeGoodsConfig: function() {
      let that = this;
      getConfig(that.code)
        .then(res => {
          that.weekend = res.data.weekend;
          that.holidays = res.data.holidays;
          that.dateList = res.data.dateList;
          that.minDate = new Date(new Date().setDate(new Date().getDate() + res.data.dayNumber));
          const startDate = new Date(res.data.startDate);
          if (startDate.getTime() > that.minDate.getTime()) {
            that.minDate = startDate;
          }
          that.maxDate = new Date(res.data.endDate);
          that.tips = res.data.tips;
          // 判断时间是否在开始时间和结束时间之间
          const now = new Date().getTime();
          if (
            now > startDate.getTime() - 86400000 * 3 &&
            now < that.maxDate.getTime()
          ) {
            that.allowDelivery = true;
          }
        })
        .catch(err => {
          that.$dialog.error(err.msg);
          setTimeout(() => {
            this.$router.push({ path: "/giftticket/subscribe" });
          }, 2000);
        });
    },
    formatter(day) {
      let that = this;
      if (that.weekend == "0") {
        let week = day.date.getDay();
        if (week == 0 || week == 6) {
          day.type = "disabled";
          return day;
        }
      }
      if (that.holidays == "0") {
        let dateStr = that.formatDate(day.date);
        if (that.dateList.indexOf(dateStr) >= 0) {
          day.type = "disabled";
          return day;
        }
      }
      return day;
    },
    async submit() {
      this.loading = true;
      let name = this.receive.name,
        phone = this.receive.phone,
        model2 = this.model2,
        detail = this.receive.detail,
        code = this.receive.code,
        date = this.receive.date,
        remark = this.receive.remark;
      try {
        await this.$validator({
          code: [required(required.message("卡号"))],
          name: [required(required.message("姓名"))],
          phone: [
            required(required.message("联系电话")),
            chs_phone(chs_phone.message())
          ],
          model2: [required("请选择地址")],
          detail: [required(required.message("具体地址"))]
        }).validate({ name, phone, model2, detail, code });
      } catch (e) {
        this.loading = false;
        return validatorDefaultCatch(e);
      }
      try {
        let that = this,
          data = {
            code: code,
            date: date,
            name: name,
            phone: phone,
            address: this.address,
            detail: detail,
            remark: remark
          };
        postTakeGiftTicket(data)
          .then(res => {
            if (res.data == 0) {
              that.$dialog.toast({ mes: "提货预约提交成功，等待商家确认" });
              // 定时器（设置时间2s）
              setTimeout(() => {
                this.loading = false;
                this.$router.push({
                  path: "/giftticket/result/" + this.receive.code
                });
              }, 2000);
            } else if (res.data == 1) {
              that.$dialog.toast({ mes: "卡券信息为空" });
              // 定时器（设置时间2s）
              setTimeout(() => {
                this.loading = false;
                this.$router.push({
                  path: "/giftticket/detail/" + this.receive.code
                });
              }, 2000);
            } else if (res.data == 2) {
              that.$dialog.toast({ mes: "卡券已使用" });
              // 定时器（设置时间2s）
              setTimeout(() => {
                this.loading = false;
                this.$router.push({
                  path: "/giftticket/result/" + this.receive.code
                });
              }, 2000);
            } else if (res.data == 3) {
              that.$dialog.toast({ mes: "未到领取时间" });
              // 定时器（设置时间2s）
              setTimeout(() => {
                this.loading = false;
                this.$router.push({
                  path: "/giftticket/detail/" + this.receive.code
                });
              }, 2000);
            } else if (res.data == 4) {
              that.$dialog.toast({ mes: "卡券已过有效期" });
              // 定时器（设置时间2s）
              setTimeout(() => {
                this.loading = false;
                this.$router.push({
                  path: "/giftticket/detail/" + this.receive.code
                });
              }, 2000);
            } else if (res.data == 5) {
              that.$dialog.toast({ mes: "卡券领取次数已用完" });
              // 定时器（设置时间2s）
              setTimeout(() => {
                this.loading = false;
                this.$router.push({
                  path: "/giftticket/detail/" + this.receive.code
                });
              }, 2000);
            }
          })
          .catch(err => {
            this.loading = false;
            that.$dialog.error(err.msg);
            if (err.msg.indexOf("未验证")) {
              setTimeout(() => {
                this.$router.push({ path: "/giftticket/subscribe" });
              }, 2000);
            }
          });
      } catch (e) {
        this.$dialog.error(e.msg);
      }
    },
    result2(ret) {
      this.model2 = ret.itemName1 + " " + ret.itemName2 + " " + ret.itemName3;
      this.address.province = ret.itemName1;
      this.address.city = ret.itemName2;
      this.address.city_id = ret.itemValue2;
      this.address.district = ret.itemName3;
    },

    mousedownFn: function(e) {
      if (!this.confirmSuccess) {
        e.preventDefault && e.preventDefault(); //阻止文字选中等 浏览器默认事件
        this.mouseMoveStata = true;
        this.beginClientX = e.changedTouches[0].clientX;
      }
    },
    successFunction() {
      //mousedoen 事件
      this.confirmSuccess = true;
      this.confirmWords = "验证通过";
      if (window.addEventListener) {
        document
          .getElementsByTagName("html")[0]
          .removeEventListener("touchmove", this.mouseMoveFn);
        document
          .getElementsByTagName("html")[0]
          .removeEventListener("touchend", this.moseUpFn);
      } else {
        document
          .getElementsByTagName("html")[0]
          .removeEventListener("touchend", () => {});
      }
      document.getElementsByClassName("drag_text")[0].style.color = "#fff";
      document.getElementsByClassName("handler")[0].style.left =
        this.maxwidth + "px";
      document.getElementsByClassName("drag_bg")[0].style.width =
        this.maxwidth + "px";
      console.log("验证通过");
    },
    mouseMoveFn(e) {
      //验证成功函数
      if (this.mouseMoveStata) {
        let width = e.changedTouches[0].clientX - this.beginClientX;
        if (width > 0 && width <= this.maxwidth) {
          document.getElementsByClassName("handler")[0].style.left =
            width + "px";
          document.getElementsByClassName("drag_bg")[0].style.width =
            width + "px";
        } else if (width > this.maxwidth) {
          this.successFunction();
        }
      }
    },
    moseUpFn(e) {
      //mousemove事件
      this.mouseMoveStata = false;
      const width = e.changedTouches[0].clientX - this.beginClientX;
      if (width < this.maxwidth) {
        document.getElementsByClassName("handler")[0].style.left = 0 + "px";
        document.getElementsByClassName("drag_bg")[0].style.width = 0 + "px";
      }
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      const day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      return year + "-" + month + "-" + day;
    },
    onConfirm(date) {
      this.show = false;
      this.receive.date = this.formatDate(date);
      this.checkDate(this.receive.date)
    },
    checkDate(date) {
      if (this.allowDelivery) {
        return;
      }
      const dateTime = new Date(date).getTime();
      if (dateTime >= this.minDate.getTime() && dateTime <= this.maxDate.getTime()) {
        this.allowDelivery = true;
      } else {
        this.allowDelivery = false;
      }
    }
  }
};
</script>

<style scoped>
.drag {
  position: relative;
  background-color: #e8e8e8;
  width: 80%;
  height: 34px;
  line-height: 34px;
  text-align: center;
  margin-top: 30px;
  margin-left: 36px;
}
.handler {
  width: 40px;
  height: 32px;
  border: 1px solid #ccc;
  cursor: move;
}
.handler_bg {
  background: #fff
    url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NTEyNTVEMURGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NTEyNTVEMUNGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo2MTc5NzNmZS02OTQxLTQyOTYtYTIwNi02NDI2YTNkOWU5YmUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+YiRG4AAAALFJREFUeNpi/P//PwMlgImBQkA9A+bOnfsIiBOxKcInh+yCaCDuByoswaIOpxwjciACFegBqZ1AvBSIS5OTk/8TkmNEjwWgQiUgtQuIjwAxUF3yX3xyGIEIFLwHpKyAWB+I1xGSwxULIGf9A7mQkBwTlhBXAFLHgPgqEAcTkmNCU6AL9d8WII4HOvk3ITkWJAXWUMlOoGQHmsE45ViQ2KuBuASoYC4Wf+OUYxz6mQkgwAAN9mIrUReCXgAAAABJRU5ErkJggg==")
    no-repeat center;
}
.handler_ok_bg {
  background: #fff
    url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NDlBRDI3NjVGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NDlBRDI3NjRGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDphNWEzMWNhMC1hYmViLTQxNWEtYTEwZS04Y2U5NzRlN2Q4YTEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+k+sHwwAAASZJREFUeNpi/P//PwMyKD8uZw+kUoDYEYgloMIvgHg/EM/ptHx0EFk9I8wAoEZ+IDUPiIMY8IN1QJwENOgj3ACo5gNAbMBAHLgAxA4gQ5igAnNJ0MwAVTsX7IKyY7L2UNuJAf+AmAmJ78AEDTBiwGYg5gbifCSxFCZoaBMCy4A4GOjnH0D6DpK4IxNSVIHAfSDOAeLraJrjgJp/AwPbHMhejiQnwYRmUzNQ4VQgDQqXK0ia/0I17wJiPmQNTNBEAgMlQIWiQA2vgWw7QppBekGxsAjIiEUSBNnsBDWEAY9mEFgMMgBk00E0iZtA7AHEctDQ58MRuA6wlLgGFMoMpIG1QFeGwAIxGZo8GUhIysmwQGSAZgwHaEZhICIzOaBkJkqyM0CAAQDGx279Jf50AAAAAABJRU5ErkJggg==")
    no-repeat center;
}
.drag_bg {
  background-color: #7ac23c;
  height: 34px;
  width: 0px;
}
.drag_text {
  position: absolute;
  top: 0px;
  width: 100%;
  text-align: center;
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;
  -o-user-select: none;
  -ms-user-select: none;
}

.checkDate {
  font-size: 0.3rem;
  color: #333333;
}
.noCheckedDate .van-cell__value--alone {
  font-size: 0.3rem;
  color: #cccccc;
}

.tips {
  margin: 0.5rem;
  color: #ea3526;
  font-size: 0.3rem;
}

.nokeepBnt {
  width: 6.9rem;
  height: 0.86rem;
  border-radius: 0.5rem;
  text-align: center;
  line-height: 0.86rem;
  margin: 0.5rem auto 0.3rem auto;
  font-size: 0.32rem;
  color: #fff;
  background: linear-gradient(to right, #f36d63 0%, #f36d63 100%);
  background: -webkit-linear-gradient(to right, #f36d63 0%, #f36d63 100%);
  background: -moz-linear-gradient(to right, #f36d63 0%, #f36d63 100%);
  text-align: center;
  line-height: 0.86rem;
  margin-top: 0.47rem;
}
.addAddress .item /deep/.van-cell {
  padding: 10px 0;
}
</style>
